// クイックスタート用サンプルプリフィル定義
// dashboard の 4 カード → /create/template?mode=X&sample=1 経由で利用
//
// 運用差し替えはこのファイル内のみで完結する。

export type QuickStartMode = "image" | "text" | "outfit" | "age";

export type SampleAssetSpec = {
  /** public/ 配下の相対パス。runtime で origin を付けて絶対化 */
  publicPath: string;
  /** 表示用ファイル名 */
  displayName: string;
};

export type SampleDefaults = {
  /** 参照画像（image / outfit モード） */
  referenceImage?: SampleAssetSpec;
  /** 自由記述（text モード） */
  freeText?: string;
  /** 任意プロンプト（outfit / image / age モード） */
  prompt?: string;
  /** 現在年齢（age モード） */
  currentAge?: number;
  /** なりたい年齢（age モード） */
  targetAge?: number;
};

export const SAMPLE_DEFAULTS: Record<QuickStartMode, SampleDefaults> = {
  image: {
    referenceImage: {
      publicPath: "/templates/anime/background.jpg",
      displayName: "（サンプル参照画像）",
    },
  },
  text: {
    freeText: "侍の鎧を着た戦国武将",
  },
  outfit: {
    referenceImage: {
      publicPath: "/templates/character/background.jpg",
      displayName: "（サンプル服装画像）",
    },
    prompt: "白いウェディングドレス",
  },
  age: {
    currentAge: 40,
    targetAge: 70,
  },
};

export function isQuickStartMode(v: unknown): v is QuickStartMode {
  return v === "image" || v === "text" || v === "outfit" || v === "age";
}

/** 絶対URL化（SSR 時は publicPath をそのまま返す） */
export function resolveSampleUrl(publicPath: string): string {
  if (typeof window === "undefined") return publicPath;
  return `${window.location.origin}${publicPath}`;
}
